import MdAutocomplete from "./MdAutocomplete"

const MdAutocompletePlugin = {
  install(app) {
    app.component(MdAutocomplete.name, MdAutocomplete)
  },
}

export default MdAutocompletePlugin
